import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e51ea80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lock-screen"
}
const _hoisted_2 = { class: "lock-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Votre session Gymya a été verrouillée pour des raisons de sécurité.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Veuillez entrer votre code PIN pour déverrouiller votre session et continuer à utiliser l’application. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warning" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" ⚠️ Le code PIN par défaut est "),
    /*#__PURE__*/_createElementVNode("b", null, "1230"),
    /*#__PURE__*/_createTextVNode(". Veuillez le modifier pour plus de sécurité et le mémoriser. ")
  ])
], -1))
const _hoisted_7 = { class: "" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "error" }, " Veuillez vérifier votre code et réessayer. ", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import { ref } from 'vue'
import { useAppLock } from '@/composables/lock/useAppLock'
import { user } from '@/shared/state';


export default /*#__PURE__*/_defineComponent({
  __name: 'LockScreen',
  setup(__props) {

const pin = ref<string>('')
const error = ref<boolean>(false)

const {
    isLocked,
    checkPin,
    unlockApp
} = useAppLock()

const unlock = () => {
    if (checkPin(pin.value)) {
        unlockApp()
        pin.value = ''
        error.value = false
    } else {
        error.value = true
    }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_unref(isLocked))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _createTextVNode("Bonjour "),
              _createElementVNode("b", null, _toDisplayString(_unref(user)?.firstName || '') + " " + _toDisplayString(_unref(user)?.lastName || ''), 1),
              _createTextVNode(", ")
            ]),
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pin).value = $event)),
              type: "password",
              placeholder: "Enter PIN",
              onKeyup: _withKeys(unlock, ["enter"]),
              class: "form-control"
            }, null, 544), [
              [_vModelText, pin.value]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: unlock,
              class: "btn btn-search mr-2"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-lock-open",
                size: "lg",
                class: "link-icon"
              }),
              _createTextVNode(" Unlock ")
            ])
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})